module.exports = __webpack_public_path__ + "img/arrow.29b1beb7.svg";